import React from "react";
import { currentWorkspaceHipaa } from "src/utils";
import { Text } from "@100mslive/roomkit-react";

const HipaaComplianceNotice = () => {
  return currentWorkspaceHipaa() ? (
    <>
      <Text
        variant="caption"
        css={{
          mt: "$4",
          color: "$on_surface_medium",
          display: "inline",
        }}
      >
        Disabled for HIPAA compliant workspaces.&nbsp;
        <a
          href={`${process.env.REACT_APP_WEBSITE_URL}docs/get-started/v2/get-started/security-and-privacy/HIPAA%20compliance/HIPAA-workspace`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Text
            variant="caption"
            css={{ c: "$primary_bright", fontWeight: "$regular" }}
            as="span"
          >
            Learn more
          </Text>
        </a>
      </Text>
    </>
  ) : null;
};

export default HipaaComplianceNotice;
